<br>

<p-panel>
  <div style="display: flex; max-width: 20%; position: absolute; right: 2rem;" *ngIf="showTareasOtrosImagen">
    <input type="file" #adjuntarFoto (change)="fileChange($event)" style="display: none;" accept="image/*"/>
    <button *ngIf="model?.adjunto" class="btn btn-link" (click)="verAdjunto()">Ver</button>
    <input type="button" class="btn btn-success"
      style='border-radius: 5px;
        font-size: 1em;
        padding: 6px 12px;
        font-family: "Roboto", "Trebuchet MS", Arial, Helvetica, sans-serif;'
      value="Añadir foto" (click)="readUrl(adjuntarFoto)" />
  </div>

  @if (!formReady) {
    <div class="d-flex justify-content-center align-items-center" style="min-height: 300px;">
      <p-progressSpinner
        strokeWidth="4"
        [style]="{width: '60px', height: '60px'}"
        animationDuration=".8s">
      </p-progressSpinner>
    </div>
  }

  @if (formReady) {
    <app-reactive-form-builder
      (formChanges)="formChanges($event[0], $event[1])"
      (goBack)="goBack()"
      (afterSend)="afterSend()"
      [form]="form.formFieldsReactive"
      [dropdownLoadTrigger]="dropdownLoadTrigger"
      [dropdownsFinalized]="dropdownsFinalized"
      [id]="getModel().id ?? ''"
      [request]="this.getType() === 1 ? this.tareasApi.otras.PUT : this.tareasApi.otras.POST"
      [getRequest]="tareasApi.otras.GET">
    </app-reactive-form-builder>

    <div class="row">
      <div class="col-md-6">
        <app-dictado *ngIf="this.appName === 'ava'"
          mensaje="Grabar observaciones"
          [observaciones]="model.observaciones ?? ''"
          (sendObservaciones)="getObservaciones($event)">
        </app-dictado>
      </div>
    </div>
    <br>
    @if ((this.appName === 'tomega' && this.rolUser !== 'aplicador') || this.appName !== 'tomega') {
      <p>TRABAJADORES SELECCIONADOS: {{seleccionados}}</p>
    }
  }
</p-panel>
<br>
<p-toast styleClass="custom-toast" [style]="{'zIndex': '1010'}"></p-toast>
